import * as angular from "angular";
import {WorkingSlotEntity} from "../models/working-slot.model";

export class WorkingSlotsRequests {

  /* @ngInject */
  constructor(private WorkingSlotsAPI, private $workingSlots) {
  }

  get(agentIds: string[], from: number, to: number, limit?: number) {
    const api = this.WorkingSlotsAPI.actions.get;
    return this.$$call(api, {agentIds: agentIds, from: from, to: to, limit: limit}, {}, {});
  }

  create(workingSlots: WorkingSlotEntity[], zoneId: string, overrideIds?: string[], override?: boolean) {
    const api = this.WorkingSlotsAPI.actions.create;
    return this.$$call(api, {zoneId: zoneId, overrideIds: overrideIds, override: override}, workingSlots, {});
  }

  updateOne(workingSlot: WorkingSlotEntity, workingSlotId: string, zoneId: string, overrideIds?: string[], override?: boolean) {
    const api = this.WorkingSlotsAPI.actions.updateOne;
    return this.$$call(api,
      {
      zoneId: zoneId,
      overrideIds: overrideIds,
      override: override
    },
      workingSlot, {id: workingSlotId});
  }

  deleteOne(id) {
    const api = this.WorkingSlotsAPI.actions.deleteOne;
    return this.$$call(api, {}, {}, {id: id});
  }

  validateWorkingSlots(workingSlots: WorkingSlotEntity[], zoneId: string) {
    const api = this.WorkingSlotsAPI.actions.validateWorkingSlots;
    return this.$$call(api, {zoneId: zoneId}, workingSlots, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$workingSlots().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.working-slots')
  .service('workingSlotsRequests', WorkingSlotsRequests);
